export const CUSTOM_THRESHOLD = "customThreshold"